import React, { useState } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import { SubHeader } from '../headers/SubHeader';
import { AddOptionButton } from './AddOptionButton';
import { AddOptionModal } from './AddOptionModal';
import { AddOptionSelections } from './AddOptionSelections';

import layoutStyles from '../../layouts/CheckoutLayout.module.scss';
import { useTranslation } from 'react-i18next';

type RequestsInputProps = {
	formRegister: UseFormRegisterReturn;
	currentNote: string;
	isEditEnabled?: boolean;
	isSaveEnabled: boolean;
	onSave?: () => void;
	label?: string; // Section title
	buttonLabel?: string; // Button label
	modalTitle?: string; // Modal title
	modalDescription?: string; // Modal description
	placeholder?: string; // Textarea placeholder
};

export const RequestsInput = ({
	formRegister,
	isEditEnabled = true,
	isSaveEnabled,
	currentNote,
	onSave,
	label,
	buttonLabel,
	modalTitle,
	modalDescription,
	placeholder
}: RequestsInputProps) => {
	const [isEditing, setIsEditing] = useState(false);
	const { t } = useTranslation();

	const computedLabel = label ?? t('titles.add_a_note', { defaultValue: 'Add a note' });
	const computedButtonLabel = buttonLabel ?? t('actions.add_note', { defaultValue: 'Add a note' });
	const computedModalTitle = modalTitle ?? t('titles.add_a_note', { defaultValue: 'Add a note' });
	const computedModalDescription = modalDescription ?? t('messages.add_note_description', { defaultValue: 'Provide any other notes for the restaurant here.' });
	const computedPlaceholder = placeholder ?? t('placeholders.write_note_here', { defaultValue: 'Write your note here...' });

	return (
		<div className={layoutStyles.Section}>
			<SubHeader title={computedLabel} isOptional />

			<div className={layoutStyles.SubSection}>
				{isEditEnabled && (
					<AddOptionButton
						label={computedButtonLabel}
						onClick={() => setIsEditing(true)}
						aria-label={t('a11y.select_dining_occasion', { defaultValue: computedButtonLabel + ' ' + t('labels.optional') })}
					/>
				)}

				<AddOptionSelections note={currentNote} />
			</div>

			<AddOptionModal
				title={computedModalTitle}
				screenReaderDescription={computedModalDescription}
				open={isEditing}
				setOpen={setIsEditing}
				onSave={onSave}
				isSaveEnabled={isSaveEnabled}
			>
				<div className='InputContainer'>
					<label id='srequests-label' htmlFor='requests-input' hidden>
						{computedLabel}
					</label>
					<textarea
						{...formRegister}
						id='requests-input'
						aria-labelledby='requests-label'
						placeholder={computedPlaceholder}
						rows={5}
						maxLength={300}
					/>
				</div>
			</AddOptionModal>
		</div>
	);
};
